<template>
  <sdCards :title="$t('pages.apps.review.title')">
    <a-row :gutter="16">
      <a-col :span="16">
        <a-row :gutter="16">
          <a-col :span="6">
            <sdButton
              size="small"
              type="info"
              @click="update(3)"
              :disabled="$store.state.application.app_detail.review_process_id != 2"
            >
              {{ $t('pages.apps.review.start-review') }}
            </sdButton>
          </a-col>
          <a-col :span="6">
            <sdButton
              size="small"
              type="warning"
              @click="update(2)"
              :disabled="$store.state.application.app_detail.review_process_id != 3"
            >
              {{ $t('pages.apps.review.send-review') }}
            </sdButton>
          </a-col>
          <a-col :span="6">
            <sdButton
              size="small"
              type="success"
              @click="update(4)"
              :disabled="$store.state.application.app_detail.review_process_id != 3"
            >
              {{ $t('pages.apps.review.complete-review') }}
            </sdButton>
          </a-col>
          <a-col :span="6">
            <sdButton
              size="small"
              type="danger"
              @click="adminNoteVisible = true"
              :disabled="$store.state.application.app_detail.review_process_id != 3"
            >
              {{ $t('pages.apps.review.reject-review') }}
            </sdButton>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="4">
        <a-tooltip placement="top">
          <template #title>
            <span>{{
              $store.state.application.app_detail.active == 1
                ? $t('pages.apps.review.deactivate')
                : $t('pages.apps.review.activate')
            }}</span>
          </template>
          <sdButton
            size="small"
            :type="$store.state.application.app_detail.active == 1 ? 'success' : 'danger'"
            @click="active()"
          >
            {{
              $store.state.application.app_detail.active == 1
                ? $t('pages.apps.review.active')
                : $t('pages.apps.review.not-active')
            }}</sdButton
          >
        </a-tooltip>
      </a-col>
      <a-col :span="4">
        <a-tooltip placement="top">
          <template #title>
            <span>{{
              $store.state.application.app_detail.is_draft == 1
                ? $t('pages.apps.review.out-in-draft')
                : $t('pages.apps.review.send-draft')
            }}</span>
          </template>
          <sdButton
            size="small"
            :type="$store.state.application.app_detail.is_draft == 1 ? 'danger' : 'success'"
            @click="draft()"
          >
            {{
              $store.state.application.app_detail.is_draft == 1
                ? $t('pages.apps.review.in-draft')
                : $t('pages.apps.review.not-in-draft')
            }}
          </sdButton>
        </a-tooltip>
      </a-col>
    </a-row>
    <br />
    <br />
    <a-table :columns="columns" :data-source="tableData" size="small">
      <template #expandedRowRender="{ record }">
        <a-row :gutter="16">
          <a-col :span="6">
            <h3 v-if="record.old_data.length != 0">
              <b>{{ $t('pages.apps.review.new-data') }}</b>
            </h3>
            <span v-for="(text, key) in record.data" :key="key">
              <b>{{ key }}:</b> {{ text }} <br />
            </span>
          </a-col>
          <a-col :span="6" v-if="record.old_data.length != 0">
            <h3>
              <b>{{ $t('pages.apps.review.old-data') }}</b>
            </h3>
            <span v-for="(text, key) in record.old_data" :key="key">
              <b>{{ key }}:</b> {{ text }} <br /> </span
          ></a-col>
        </a-row>
      </template>
    </a-table>
  </sdCards>

  <a-modal v-model:visible="adminNoteVisible" :title="$t('pages.apps.review.admin_note')" @ok="saveAdminNote">
    <a-textarea v-model:value="adminNote" :placeholder="$t('pages.apps.review.admin_note')" :rows="4" />
  </a-modal>
</template>
<script>
import { dateToTr } from '@/utility/helper.js';
import { mapGetters } from 'vuex';
export default {
  name: 'reviewRoot',
  components: {},
  data() {
    return {
      app_id: this.$route.params.id,
      adminNoteVisible: false,
      adminNote: '',
      data: [],
      tableData: [],
      columns: [
        {
          title: this.$t('pages.apps.review.setting'),
          dataIndex: 'setting',
          key: 'setting',
        },
        {
          title: this.$t('pages.apps.review.change'),
          dataIndex: 'type',
          key: 'type',
        },
        {
          title: this.$t('pages.apps.review.date'),
          dataIndex: 'update_date',
          key: 'update_date',
        },
      ],
    };
  },
  methods: {
    update(id) {
      const formData = {
        app_id: this.app_id,
        process_id: id,
        admin_note: this.adminNote,
      };
      this.$appAxios.post(this.$endpoints.app_review_root_update, formData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
          this.$store.dispatch('application/get', this.app_id);
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
    jsonToString(data) {
      var str = '';
      for (const [key, value] of Object.entries(data)) {
        str += `<b>${key}:</b> ${value}<br>\n`;
      }
      return str;
    },
    getChanges() {
      const formData = {
        app_id: this.app_id,
      };
      this.$appAxios.post(this.$endpoints.app_review_changes_get, formData).then((resp) => {
        if (resp.data.status) {
          this.data = resp.data.data;
          var _this = this;
          this.data.logs.forEach(function (item, index) {
            _this.tableData.push({
              key: index,
              setting: item.setting,
              type: item.type,
              update_date: dateToTr(item.update_date),
              data: item.data,
              old_data: item.old_data,
            });
          });
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
    active() {
      const formData = {
        app_id: this.app_id,
        value: this.$store.state.application.app_detail.active == 1 ? 0 : 1,
      };
      this.$appAxios.post(this.$endpoints.app_active_set, formData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
          this.$store.state.application.app_detail.active = formData.value;
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
    draft() {
      const formData = {
        app_id: this.app_id,
        value: this.$store.state.application.app_detail.is_draft == 1 ? 0 : 1,
      };
      this.$appAxios.post(this.$endpoints.app_draft_set, formData).then((resp) => {
        if (resp.data.status) {
          this.$store.state.application.app_detail.is_draft = formData.value;
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
    saveAdminNote() {
      this.update(5);
      this.adminNoteVisible = false;
    },
  },
  mounted() {
    if (atob(this.$store.state.auth.is_root) != 1) {
      this.$router.push({ name: 'app-list' });
      return false;
    }
    this.getChanges();
  },
  computed: {
    ...mapGetters({
      app: 'application/app_detail',
    }),
  },
};
</script>
